/** @format */

export const zendeskRequestInfoUrlGenerator = ({
  city = '',
  roomCode,
  price,
  countryCode,
}: {
  city: string;
  roomCode: string;
  price: number;
  countryCode: string;
}) => {
  // italian room.contryCode = 'IT'
  const baseUrl =
    countryCode === 'ESP' || countryCode === 'ES'
      ? 'https://dovevivospain.zendesk.com/hc/requests/new'
      : 'https://helpcenter.dovevivo.com/hc/requests/new';
  const queryParams = new URLSearchParams();
  queryParams.append('tf_15700668171921', `citta_${city.toLowerCase()}`); // city in italian
  queryParams.append('tf_27363846955665', roomCode); // room code
  queryParams.append('ticket_form_id', '27344475339537'); // fixed value
  queryParams.append('tf_28512021651985', price.toFixed(2)); // room price
  queryParams.append('tf_29515720192401', 'dovevivo'); // brand

  const url = `${baseUrl}?${queryParams.toString()}`;

  return url;
};
